
const digest = '66bb6733edebebb30f7e0cf77a39fde4bc6d575b6cbac4bd12b878bff72b200a';
const classes = {"wrapper":"_wrapper_1v0mx_1","input":"_input_1v0mx_4","iconWrapper":"_iconWrapper_1v0mx_17"};
const css = `._wrapper_1v0mx_1 {
  position: relative;
}
._wrapper_1v0mx_1 ._input_1v0mx_4 {
  border: 1px solid #c1cbe4 !important;
  min-height: 55px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 15px;
  box-shadow: inset 0 3px 0 0 rgba(198, 214, 240, 0.5);
  padding: 16px 40px 16px 20px !important;
  color: #000;
  background-color: #dce7fa;
  position: relative;
  width: 100%;
}
._wrapper_1v0mx_1 ._iconWrapper_1v0mx_17 {
  height: 25px;
  width: 30px;
  background-color: #ffffff;
  position: absolute;
  right: 20px;
  top: calc(50% - 12px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
._wrapper_1v0mx_1 ._iconWrapper_1v0mx_17 img {
  height: 16px;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  